<template>
  <ServiceItem
    v-if="start"
    :title="'CallTouch'"
    :status="status"
    :channel-slug="channelSlug"
    :icon="require('../../../assets/images/calltouch-logo.svg')"
    :custom-text="custom_text"
    :custom-peer="custom_peer"
    page-name-to-add="channels_calltouch_add"
    page-name-to-edit="channels_calltouch_edit"
    @delete="handleDelete"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceItem from './ServiceItem'
import CallTouchService from '../../../api/http/models/calltouch/CallTouchService'

export default {
  props: {
    channelSlug: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      start: false,
      status: '',
      custom_text: '',
      custom_peer: ''
    }
  },

  components: {
    ServiceItem
  },

  async created () {
    const response = await CallTouchService.get(this.authUserCompany.slug, this.channelSlug)

    if (response.data) {
      this.status = response.data.status
      this.custom_text = !response.data.enabled ? '(сервис отключен)' : ''
      this.custom_peer = !response.data.enabled ? 'disable-peer' : ''
    } else {
      this.status = 'ready_to_add'
    }

    this.start = true
  },

  computed: {
    ...mapGetters(['authUserCompany'])
  },

  methods: {
    async handleDelete () {
      const response = await CallTouchService.delete(this.authUserCompany.slug, this.channelSlug)

      if (response.status === 'success') {
        this.$vs.notify({
          color: 'success',
          title: 'CallTouch успешно удален',
          text: ''
        })
        this.status = 'ready_to_add'
      }
    }
  }
}
</script>
